const jobLevelOptions = [
  {
    key: 'Admin',
    text: 'Admin',
    value: 'Admin',
  },
  {
    key: 'Advisor / Counselor',
    text: 'Advisor / Counselor',
    value: 'Advisor / Counselor',
  },
  {
    key: 'Assistant / Associate Director',
    text: 'Assistant / Associate Director',
    value: 'Assistant / Associate Director',
  },
  {
    key: 'Dean',
    text: 'Dean',
    value: 'Dean',
  },
  {
    key: 'Director',
    text: 'Director',
    value: 'Director',
  },
  {
    key: 'Faculty',
    text: 'Faculty',
    value: 'Faculty',
  },
  {
    key: 'Manager',
    text: 'Manager',
    value: 'Manager',
  },
  {
    key: 'Marketing',
    text: 'Marketing',
    value: 'Marketing',
  },
  {
    key: 'President / Provost / Chancellor',
    text: 'President / Provost / Chancellor',
    value: 'President / Provost / Chancellor',
  },
  {
    key: 'Vice President / Vice Provost / Vice Chancellor',
    text: 'Vice President / Vice Provost / Vice Chancellor',
    value: 'Vice President / Vice Provost / Vice Chancellor',
  },
  {
    key: 'Other',
    text: 'Other',
    value: 'Other',
  },
];

export default jobLevelOptions;
